// @flow
import * as React from 'react';
import styled from 'styled-components';
import colors from "../../assets/css/colors";
import "react-toggle/style.css";

const SwitchToggleLabel = styled.label`
	font-size: 12px;
	line-height: 1.5;
	color: ${colors.darkGrey};
	margin-left: 5px;
	cursor: pointer;
`;

const SwitchToggleStyled = styled.div`
	display: flex;
	align-items: center;
	margin-right: 1em;

	.custom-checkbox {
		position: relative;
		cursor: pointer;
		height: 16px;
		width: 28px;
		border-radius: 100px;
		background: ${colors.toggle_background};
		transform: translate3d(0,0,0);

		&:before {
			content: '';
			position: absolute;
			left: 2px;
			top: 1px;
			border-radius: 50%;
			display: block;
			height: 14px;
			width: 14px;
			background-color: #FFFFFF;
			box-shadow: 0 1px 1px 0 rgba(0,0,0,0.25);
		}
	}

	input {
		visibility: hidden;
		width: 0;
		margin: 0;

		&:checked + label {
			background: ${colors.nrlGreen};

			&:before {
				right: 2px;
				left: auto;
			}
		}
	}
`;

type Props = {
	id: string,
	name: string,
	checked?: boolean,
	onChange?: Function,
	label?: string,
	className?: string,
	disabled?: boolean,
	value?: boolean,
};

export const SwitchToggle = ({
	name,
	id,
	checked,
	value,
	onChange,
	label,
	className,
	disabled = false,
}: Props) => (
	<SwitchToggleStyled id={`id-${id}`} className={className}>
		<input type="checkbox"
			defaultChecked={checked}
			checked={value}
			id={id}
			name={name}
			onChange={onChange}
			disabled={disabled}
			readOnly
		/>
		<label className='custom-checkbox' htmlFor={id} />

		{label ? (<SwitchToggleLabel htmlFor={id}>{label}</SwitchToggleLabel>) : null}
	</SwitchToggleStyled>
);

export default SwitchToggle;


// WEBPACK FOOTER //
// ./src/components/SwitchToggle/index.js